<div class="therapie-section" *ngIf="therapieObj">

    <div class="therapie-rows">
        <ng-container *ngFor="let response of therapieObj.responseData">
            <div class="therapie-row">
                <div class="therapie-block">
                    <div class="therapie-item category-icon" [ngSwitch]="response['category'].value">
                        <img *ngSwitchCase="'Cannabisextrakt'" src="/pep/images/icons/Extract.svg" />
                        <img *ngSwitchCase="'Cannabis extract'" src="/pep/images/icons/Extract.svg" />
                        <img *ngSwitchCase="'Cannabisblüten'" src="/pep/images/icons/Flower.svg" />
                        <img *ngSwitchCase="'Cannabis flowers'" src="/pep/images/icons/Flower.svg" />
                        <img *ngSwitchCase="'Dronabinol'" src="/pep/images/icons/Dronabinol.svg" />
                        <img *ngSwitchCase="'Sativex'" src="/pep/images/icons/Sativex.svg" />
                        <img *ngSwitchCase="'Canemes'" src="/pep/images/icons/Kapsel.svg" />
                        <img *ngSwitchCase="'Cesamet'" src="/pep/images/icons/Kapsel.svg" />
                        <img *ngSwitchCase="'Kapseln'" src="/pep/images/icons/Kapsel.svg" />
                        <img *ngSwitchCase="'Capsules'" src="/pep/images/icons/Kapsel.svg" />
                        <img *ngSwitchCase="'Andere'" src="/pep/images/icons/Flower.svg" />
                        <img *ngSwitchCase="'Other'" src="/pep/images/icons/Flower.svg" />
                        <ng-container *ngSwitchDefault>
                            <div class="no-icon"></div>
                        </ng-container>
                    </div>
                    <div class="therapie-item">
                        <ng-container *ngTemplateOutlet="inputTemplate;context:{response:response,itemKey:'category'}"></ng-container>
                    </div>
                    <div class="therapie-item">
                        <ng-container *ngTemplateOutlet="inputTemplate;context:{response:response,itemKey:'product'}"></ng-container>
                    </div>
                </div>
                <div class="therapie-block gray-block">
                    <div class="therapie-item">
                        <ng-container *ngTemplateOutlet="inputTemplate;context:{response:response,itemKey:'startDate'}"></ng-container>
                    </div>
                    <div class="therapie-item">
                        <ng-container *ngIf="therapieObj.therapieName==EnumCAMTherapieName.CAMTherapieEnd">
                            <ng-container *ngTemplateOutlet="inputTemplate;context:{response:response,itemKey:'endDate'}"></ng-container>
                        </ng-container>
                        <ng-container *ngIf="therapieObj.therapieName!=EnumCAMTherapieName.CAMTherapieEnd">
                            <ng-container *ngTemplateOutlet="inputTemplate;context:{response:response,itemKey:'phaseDuration'}"></ng-container>
                        </ng-container>
                    </div>
                </div>
                <div class="therapie-block blue-block">
                    <div class="therapie-item">
                        <ng-container *ngTemplateOutlet="inputTemplate;context:{response:response,itemKey:'applicationUnit'}"></ng-container>
                    </div>
                    <div class="therapie-item">
                        <ng-container *ngTemplateOutlet="inputTemplate;context:{response:response,itemKey:'dailyDosage'}"></ng-container>
                    </div>
                </div>
                <div class="therapie-block">
                    <div class="therapie-item">
                        <ng-container *ngTemplateOutlet="inputTemplate;context:{response:response,itemKey:'remarks'}"></ng-container>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="form-buttons-with-text extra-option" *ngIf="therapieObj.addMore">
        <div class="form-buttons">
            <div class="form-button" (click)="fnAddExtraOption()" [class.disabled]="subSection.status==EnumSectionStatus.COMPLETED">
                <ng-container *ngIf="subSection.status==EnumSectionStatus.COMPLETED">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="36px" height="36px" viewBox="0 0 30 30" version="1.1">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <circle id="Oval" fill="#DCDCDC" cx="14.6341463" cy="15.3658537" r="14.6341463" />
                            <line x1="7.62195122" y1="15.4268293" x2="21.6463415" y2="15.4268293" id="Line-2-Copy" stroke="#FFFFFF" stroke-width="3" fill="#FFFFFF" stroke-linecap="round" />
                            <line x1="7.62195122" y1="15.4268293" x2="21.6463415" y2="15.4268293" id="Line-2-Copy" stroke="#FFFFFF" stroke-width="3" fill="#FFFFFF" stroke-linecap="round" transform="translate(14.634146, 15.426829) rotate(90.000000) translate(-14.634146, -15.426829) " />
                        </g>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="36px" height="36px" viewBox="0 0 30 30" version="1.1">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <circle id="Oval" fill="#DCDCDC" cx="14.6341463" cy="15.3658537" r="14.6341463" />
                            <line x1="7.62195122" y1="15.4268293" x2="21.6463415" y2="15.4268293" id="Line-2-Copy" stroke="#FFFFFF" stroke-width="3" fill="#FFFFFF" stroke-linecap="round" />
                            <line x1="7.62195122" y1="15.4268293" x2="21.6463415" y2="15.4268293" id="Line-2-Copy" stroke="#FFFFFF" stroke-width="3" fill="#FFFFFF" stroke-linecap="round" transform="translate(14.634146, 15.426829) rotate(90.000000) translate(-14.634146, -15.426829) " />
                        </g>
                    </svg>
                </ng-container>
                <ng-container *ngIf="subSection.status!=EnumSectionStatus.COMPLETED">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="36px" height="36px" viewBox="0 0 30 30" version="1.1">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <circle id="Oval" fill="#0087FF" cx="14.6341463" cy="15.3658537" r="14.6341463" />
                            <line x1="7.62195122" y1="15.4268293" x2="21.6463415" y2="15.4268293" id="Line-2-Copy" stroke="#FFFFFF" stroke-width="3" fill="#FFFFFF" stroke-linecap="round" />
                            <line x1="7.62195122" y1="15.4268293" x2="21.6463415" y2="15.4268293" id="Line-2-Copy" stroke="#FFFFFF" stroke-width="3" fill="#FFFFFF" stroke-linecap="round" transform="translate(14.634146, 15.426829) rotate(90.000000) translate(-14.634146, -15.426829) " />
                        </g>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="36px" height="36px" viewBox="0 0 30 30" version="1.1">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <circle id="Oval" fill="#0087FFBF" cx="14.6341463" cy="15.3658537" r="14.6341463" />
                            <line x1="7.62195122" y1="15.4268293" x2="21.6463415" y2="15.4268293" id="Line-2-Copy" stroke="#FFFFFF" stroke-width="3" fill="#FFFFFF" stroke-linecap="round" />
                            <line x1="7.62195122" y1="15.4268293" x2="21.6463415" y2="15.4268293" id="Line-2-Copy" stroke="#FFFFFF" stroke-width="3" fill="#FFFFFF" stroke-linecap="round" transform="translate(14.634146, 15.426829) rotate(90.000000) translate(-14.634146, -15.426829) " />
                        </g>
                    </svg>
                </ng-container>
            </div>
        </div>
        <div class="question-options">
            <div class="question-option add-button no-hover w-auto">{{therapieObj.addMore}}</div>
        </div>
    </div>
</div>

<ng-template #inputTemplate let-response="response" let-itemKey="itemKey">
    <div class="therapie-input" [class.optional]="!isItemRequired(therapieObj, response, itemKey)" *ngIf="isItemVisible(therapieObj, response, itemKey)">
        <div class="question-text">{{getLabelName(therapieObj, response, itemKey)}}</div>
        <ng-container [ngSwitch]="getItemInputType(therapieObj, response, itemKey)">
            <ng-container *ngSwitchCase="EnumQuestionType.INPUT">
                <input type="text" class="form-control" [class.has-error]="response.hasError[itemKey]" [(ngModel)]="response[itemKey].value"
                       [disabled]="subSection.status==EnumSectionStatus.COMPLETED"
                       (change)="changeFunction(therapieObj, response, itemKey)"
                       [placeholder]="therapieObj[itemKey].placeholder || ''" autocomplete="new-password" />
            </ng-container>
            <ng-container *ngSwitchCase="EnumQuestionType.MONTH">
                <input type="text" [(ngModel)]="response[itemKey].value" class="form-control"
                       [class.has-error]="response.hasError[itemKey]" [disabled]="subSection.status==EnumSectionStatus.COMPLETED"
                       [placeholder]="therapieObj[itemKey].placeholder || ''" (change)="changeFunction(therapieObj, response, itemKey)" autocomplete="new-password"
                       bsDatepicker [bsConfig]="{ dateInputFormat: 'MM/YYYY',minMode :'month',containerClass:'theme-dark-blue',adaptivePosition: true  }"
                       [minDate]="therapieObj[itemKey].monthObj?.minMonth || minMonth" [maxDate]="therapieObj[itemKey].monthObj?.maxMonth || maxMonth" />
            </ng-container>
            <ng-container *ngSwitchCase="EnumQuestionType.DROPDOWN">
                <ng-select [(ngModel)]="response[itemKey].value"
                           [placeholder]="therapieObj[itemKey].placeholder || ''" [multiple]="false"
                           autocomplete="new-password" [searchable]="itemKey=='product'"
                           appendTo="body" [class.has-error]="response.hasError[itemKey]"
                           [disabled]="subSection.status==EnumSectionStatus.COMPLETED"
                           (change)="changeFunction(therapieObj, response, itemKey)">
                    <ng-option *ngFor="let option of therapieOptions(response, itemKey)"
                               [value]="option">
                        {{option}}
                    </ng-option>
                </ng-select>
            </ng-container>
        </ng-container>
    </div>

    <ng-container *ngIf="isTherapieFreeTextShow(therapieObj, response, itemKey) && therapieObj[itemKey].freeTextInput">
        <div class="therapie-input">
            <ng-container [ngSwitch]="therapieObj[itemKey].freeTextInput.inputType">
                <ng-container *ngSwitchCase="EnumFreeTextType.INPUT">
                    <input type="text" class="form-control"
                           [class.has-error]="response.hasError[itemKey]" [(ngModel)]="response[itemKey].freeText"
                           [placeholder]="therapieObj[itemKey].placeholder || ''" (change)="changeFunction(therapieObj, response, itemKey)"
                           [disabled]="subSection.status==EnumSectionStatus.COMPLETED"
                           autocomplete="new-password" />

                </ng-container>
                <ng-container *ngSwitchCase="EnumFreeTextType.TEXTAREA">
                    <textarea class="form-control"
                              [class.has-error]="response.hasError[itemKey]" [(ngModel)]="response[itemKey].freeText"
                              [placeholder]="therapieObj[itemKey].placeholder || ''" rows="5" (change)="changeFunction(therapieObj, response, itemKey)"
                              [disabled]="subSection.status==EnumSectionStatus.COMPLETED"
                              autocomplete="new-password"></textarea>
                </ng-container>
            </ng-container>
        </div>
        <div class="thc-cbd-input-block" *ngIf="InEditRecordPopup && itemKey=='product'">
            <div class="thc-cbd-input">
                <div class="question-text">THC</div>
                <input type="text" class="form-control"
                       [class.has-error]="response.hasError[itemKey]['thc']" [(ngModel)]="response[itemKey]['thc']"
                       placeholder="THC" [disabled]="subSection.status==EnumSectionStatus.COMPLETED"
                       autocomplete="new-password" />
            </div>
            <div class="thc-cbd-input">
                <div class="question-text">CBD</div>
                <input type="text" class="form-control"
                       [class.has-error]="response.hasError[itemKey]['cbd']" [(ngModel)]="response[itemKey]['cbd']"
                       placeholder="CBD" [disabled]="subSection.status==EnumSectionStatus.COMPLETED"
                       autocomplete="new-password" />
            </div>
        </div>
    </ng-container>
</ng-template>
